import { createAction } from '@reduxjs/toolkit';

export const getQuestionForPractice = {
    request: createAction('question/getQuestionForPracticeRequest'),
    success: createAction('question/getQuestionForPracticeSuccess'),
    failed: createAction('question/getQuestionForPracticeFailed'),
};

export const setSelectedSection = {
    request: createAction('question/setSelectedSectionRequest'),
};
